import React from 'react';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { getItemDefaultNotes } from './_api';
import { reduxForm, Field } from 'redux-form';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import { Select } from 'redux-form-material-ui';
import { get } from 'lodash';
import { updateItem } from '../../modules/products/_api';

const required = value => (value || typeof value === 'number' ? undefined : 'Vyžadováno');

const enhance = compose(
  withState('notes', 'setNotes', []),
  lifecycle({
    async componentDidMount() {
      const { setNotes } = this.props;
      const resp = await getItemDefaultNotes();
      if (resp) {
        setNotes(resp.map((item, i) => ({ id: i, value: item })));
      }
    },
  }),
  reduxForm({ form: 'deleteItem' }),
  withHandlers({
    onSubmit: ({ handleOk, dialog, notes, change }) => async values => {
      const note = get(values, 'note', false);
      if (note) {
        await updateItem({ id: dialog.id, note: notes[note].value });
        change('note', null);
      }
      handleOk();
    },
  }),
);

export default enhance(({ open, handleCancel, dialog, classes, handleSubmit, notes, onSubmit }) => (
  <Dialog
    disableBackdropClick
    disableEscapeKeyDown
    maxWidth="xs"
    onEntering={this.handleEntering}
    aria-labelledby="confirmation-dialog-title"
    open={open}
  >
    <form onSubmit={handleSubmit(values => onSubmit(values))}>
      <DialogTitle id="confirmation-dialog-title">Smazat</DialogTitle>
      <DialogContent>
        <div> Opravdu chcete smazat vybranou položku? </div>
        {dialog.action === 'item-delete' && (
          <Grid item xs={12}>
            <FormControl style={{ minWidth: 200 }}>
              <InputLabel htmlFor="note">Poznámka</InputLabel>
              <Field name="note" component={Select} placeholder="note" validate={[required]}>
                {notes.map(item => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.value}
                  </MenuItem>
                ))}
              </Field>
            </FormControl>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button type="submit" variant="contained" color="primary">
          Ok
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          Zrušit
        </Button>
      </DialogActions>
    </form>
  </Dialog>
));



// WEBPACK FOOTER //
// ./src/components/confirmDialog/index.js